import { colors } from '@material-ui/core';

const muitablehead = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default muitablehead